import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FilterChip,
  FilterMenuItem,
} from '../filters/FilterChip';
import { DomainFilter } from '../filters/DomainFilter';
import { ModelFilter } from '../filters/ModelFilter';
import { TopicFilter } from '../filters/TopicFilter';
import type { VisibilityScoreFilter } from '../../utils/execution-filters';
import {
  DEFAULT_TOPIC_FILTERS,
  type TopicFiltersState,
} from '../../utils/topic-filters';

const VISIBILITY_OPTIONS: { id: VisibilityScoreFilter; label: string }[] = [
  { id: 'all', label: 'همه دیده‌شدن' },
  { id: '0-20', label: '0–20%' },
  { id: '20-40', label: '20–40%' },
  { id: '40-60', label: '40–60%' },
  { id: '60-80', label: '60–80%' },
  { id: '80-100', label: '80–100%' },
];

export function TopicFiltersBar({
  filters,
  onChange,
}: {
  filters: TopicFiltersState;
  onChange: (next: TopicFiltersState) => void;
}) {
  const visibilityLabel =
    VISIBILITY_OPTIONS.find(option => option.id === filters.visibility)?.label ?? 'همه دیده‌شدن';

  const hasActiveFilters = filters.search.trim() !== '' || filters.visibility !== 'all';

  return (
    <div className="mb-3 d-flex flex-wrap align-items-center justify-content-between gap-2 w-100">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <div className="position-relative" style={{ minWidth: '16rem', maxWidth: '24rem' }}>
          <FontAwesomeIcon
            icon="search"
            className="position-absolute top-50 translate-middle-y text-400"
            style={{ insetInlineStart: '0.75rem', pointerEvents: 'none' }}
          />
          <Form.Control
            type="search"
            size="sm"
            value={filters.search}
            onChange={e => onChange({ ...filters, search: e.target.value })}
            placeholder="جستجوی تاپیک‌ها…"
            className="rounded-pill border-300"
            style={{ paddingInlineStart: '2.25rem' }}
          />
        </div>

        <ModelFilter />
        <TopicFilter />
        <DomainFilter />

        <FilterChip
          icon={<FontAwesomeIcon icon="chart-line" className="fs--2" />}
          label={visibilityLabel}
          active={filters.visibility !== 'all'}
        >
          {VISIBILITY_OPTIONS.map(option => (
            <FilterMenuItem
              key={option.id}
              selected={filters.visibility === option.id}
              onClick={() => onChange({ ...filters, visibility: option.id })}
            >
              {option.label}
            </FilterMenuItem>
          ))}
        </FilterChip>

        {hasActiveFilters && (
          <Button
            type="button"
            size="sm"
            variant="link"
            className="text-decoration-none text-500 px-1"
            onClick={() => onChange(DEFAULT_TOPIC_FILTERS)}
          >
            پاک کردن
          </Button>
        )}
      </div>
    </div>
  );
}
